import React, { useRef, useEffect } from 'react';

const Turning = props => {
    return (
        <>          
          <div className='turningCountData' style={{position:'absolute',top:'0'}}>
            <span className='amnbIn'>{props.turningCountData.sbIn}</span>
            <span className='amnbEx'>{props.turningCountData.sbEx}</span>
            <span className='amsbIn'>{props.turningCountData.nbIn}</span>
            <span className='amsbEx'>{props.turningCountData.nbEx}</span>
            <span className='amebIn'>{props.turningCountData.wbIn}</span>
            <span className='amebEx'>{props.turningCountData.wbEx}</span>
            <span className='amwbIn'>{props.turningCountData.ebIn}</span>
            <span className='amwbEx'>{props.turningCountData.ebEx}</span>
            <span className='amNbLeft'>{props.turningCountData.sbLeft}</span>
            <span className='amSbLeft'>{props.turningCountData.nbLeft}</span>
            <span className='amEbLeft'>{props.turningCountData.wbLeft}</span>
            <span className='amWbLeft'>{props.turningCountData.ebLeft}</span>
            <span className='amNbRight'>{props.turningCountData.sbRight}</span>
            <span className='amSbRight'>{props.turningCountData.nbRight}</span>
            <span className='amEbRight'>{props.turningCountData.wbRight}</span>
            <span className='amWbRight'>{props.turningCountData.ebRight}</span>
            <span className='amCenterDataPHF' style={{left: props.positions ? `${props.positions.left}px` : "130px", top : props.positions ? `${props.positions.top}px` : "117px"}}>PHF</span>
            <span className='amCenterData' title='Peak Hour Factor'>{props.turningCountData.centerData}</span>
            <span className='amNbMiddle'>{props.turningCountData.sbMiddle}</span>
            <span className='amSbMiddle'>{props.turningCountData.nbMiddle}</span>
            <span className='amEbMiddle'>{props.turningCountData.wbMiddle}</span>
            <span className='amWbMiddle'>{props.turningCountData.ebMiddle}</span>
            <span className='nUturn'>{props.turningCountData.suturn}</span>
            <span className='sUturn'>{props.turningCountData.nuturn}</span>
            <span className='eUturn'>{props.turningCountData.wsuturn}</span>
            <span className='wUturn'>{props.turningCountData.euturn}</span>
          </div>
        </>
    )
}
export default Turning;